import { queryOptions } from '@tanstack/react-query';

import { queryKeys } from '@/app/constants/queryKeys';
import { QueryTimers } from '@/infra/network/query';
import { episodesService } from '@/modules/episodes/services';

const episodesDetailsQueryOptions = (projectId: string, podcastId: string, episodeId: string) =>
  queryOptions({
    gcTime: QueryTimers.FIVE_MINUTES,
    staleTime: QueryTimers.FIVE_MINUTES,
    refetchInterval: QueryTimers.FIVE_MINUTES,
    queryKey: queryKeys.episodes.detail(projectId, podcastId, episodeId),
    queryFn: () => episodesService.getEpisodeDetails({ projectId, podcastId, episodeId }),
  });

export { episodesDetailsQueryOptions };
